<template>
  <div>
    <ClientLoginComponent/>
  </div>
</template>

<script>
import ClientLoginComponent from "@/components/LoginComponents/ClientLoginComponent.vue";

export default {
  name: 'client-login-view',
  components: {ClientLoginComponent},
  title: 'ClientLogin'
}
</script>
